import { EditButton, WrapperField } from "react-admin";
import { MyList } from "../../components/MyList";
import { MyField } from "../../components/types";
import { Field, isNotRequired } from "../../utils/Field";
import React from "react";
import MyCreate from "../../components/MyCreate";
import MyEdit from "../../components/MyEdit";
import { BooleanTypeChoices, StatusTypeChoices } from "../../model/Core";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { UserWalletTypeChoices } from "../../model/UserWallet";
import {
  ExchangeOrderDirectionChoices,
  ExchangeOrderStatusChoices,
  ExchangeOrderTypeChoices,
} from "../../model/exchange";
import { MyDatagrid } from "../../components/MyDatagrid";
import { userField } from "../../utils/field/userField";
import CollectionsIcon from "@mui/icons-material/Collections";

const fields: MyField<API.Coin>[] = [
  Field.objectId(),
  Field.ref({
    label: "活期计划",
    source: "planId",
    isRequired: true,
    isList: true,
    isFilter: false,
    reference: "fundCurrentPlans",
    originSource: "planId",
    referenceLabel: "coinSymbol",
  }),
  Field.select({
    label: "水军",
    source: "isMyUser",
    maxWidth: 50,
    isFilter: true,
    choices: BooleanTypeChoices,
  }),
  userField(),
  Field.number({
    label: "认购份额",
    source: "number",
  }),
  Field.text({
    label: "币种",
    source: "coinSymbol",
  }),
  Field.amount({
    label: "利息",
    source: "historyInterest",
  }),
  Field.dateTime({
    label: "上传发息时间",
    source: "payingTime",
  }),
  Field.dateTime({
    label: "创建时间",
    source: "createdDate",
  }),
];

export const FundCurrentUserTable = () => {
  return <MyDatagrid fields={fields} rowActions={[]} />;
};

const resource = {
  list: () => {
    return (
      <MyList
        fields={fields}
        filterDefaultValues={{ isMyUser: false }}
        rowActions={[]}
        tableActions={<></>}
      />
    );
  },
  create: () => {
    return <MyCreate fields={fields} />;
  },
  edit: () => {
    return <MyEdit fields={fields} />;
  },
  icon: CollectionsIcon,
};

export default resource;
